import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { Card, CardContent, CardHeader, CardTitle } from '@/common/ui/card'

import useQueryGetFlexMessageAnalytics from '../../api/hooks/useQueryGetFlexMessageAnalytics'
import FlexAnalyticsOverviewCards from '../../components/FlexAnalyticsOverviewCards'
import FlexAnalyticsTable from '../../components/FlexAnalyticsTable'
import OpensByDayWindowChart from '../../components/OpensByDayWindowChart'

function FlexMessageAnalyticsPage() {
	const { data, isLoading } = useQueryGetFlexMessageAnalytics()

	return (
		<PageContainer>
			<div className="space-y-6">
				{/* Page Header */}
				<div>
					<h1 className="text-2xl font-bold tracking-tight">
						Flex Message Analytics
					</h1>
					<p className="text-muted-foreground">
						วิเคราะห์ประสิทธิภาพ LINE Flex Message
					</p>
				</div>

				{/* Summary Section */}
				<Card>
					<CardHeader>
						<CardTitle>ภาพรวม (Overall)</CardTitle>
						<p className="text-sm text-muted-foreground">
							สถิติรวมจาก Flex Message ทั้งหมด
						</p>
					</CardHeader>
					<CardContent className="space-y-6">
						{/* Overview KPI Cards */}
						<FlexAnalyticsOverviewCards
							overall={data?.overall}
							isLoading={isLoading}
						/>

						{/* Opens by Day Window Chart */}
						<OpensByDayWindowChart
							opensByDayWindow={data?.overall?.opensByDayWindow}
							isLoading={isLoading}
							title="การเปิดดูตามช่วงเวลา (รวมทุก Flex Message)"
						/>
					</CardContent>
				</Card>

				{/* Individual Flex Messages Table */}
				<FlexAnalyticsTable data={data?.data || []} isLoading={isLoading} />
			</div>
		</PageContainer>
	)
}

const GuardedFlexMessageAnalyticsPage = withUserPermission(
	FlexMessageAnalyticsPage,
	{
		permissionType: PermissionType.Read,
		permissionKey: [PermissionKeys.MANAGE_SMS],
	},
)

export default GuardedFlexMessageAnalyticsPage
